module.exports = __webpack_public_path__ + "media/images/founders/founder_1-13022c26540f98c4102c3e7ca51eb992.jpg";